export const UNSECURE_URL_PATTERNS: RegExp[] = [
    // Admin/Shared metadata
    /^\/api\/v1\/addresses\/types$/,
    /^\/api\/v1\/banners\/types$/,
    /^\/api\/v1\/branches\/details$/,
    /^\/api\/v1\/products\/packets$/,
    /^\/api\/v1\/products\/shipping$/,
    /^\/api\/v1\/products\/service-fee$/,
    /^\/api\/v1\/stop-list$/,
    /^\/api\/v1\/orders\/delivery\/min-price$/,
    /^\/api\/v1\/payment-types$/,
    /^\/api\/v1\/menus$/,
    /^\/api\/v1\/banners\/list$/,
    /^\/api\/v1\/combos\/list$/,
    /^\/api\/v1\/stories$/,

    // Customer & Auth
    /^\/api\/v1\/users\/login$/,
    /^\/api\/v[12]\/customer-verifications\/.*/,
    /^\/api\/v[12]\/products\/recommendations$/,
    /^\/api\/v1\/discounts\/calc$/,
    /^\/api\/v1\/sessions\/verification$/,
    /^\/resources\/icons\/.*/,
    /^\/errors$/
]

export const getRequestPathname = (url?: string, baseUrl: string = ""): string => {
    if (!url) return ""

    const cleanUrl = url.split(/[?#]/)[0]
    if (!cleanUrl) return ""

    if (/^https?:\/\//i.test(cleanUrl)) {
        try {
            return new URL(cleanUrl).pathname
        } catch {
            return cleanUrl.replace(/^https?:\/\/[^/]+/, "")
        }
    }

    if (/^\/(api|resources|errors)(\/|$)/.test(cleanUrl)) {
        return cleanUrl.replace(/\/+/g, "/")
    }

    const base = baseUrl.split(/[?#]/)[0]
    let joined = cleanUrl
    if (base) {
        if (/^https?:\/\//i.test(base)) {
            try {
                const basePath = new URL(base).pathname.replace(/\/+$/, "")
                const relPath = cleanUrl.replace(/^\/+/, "")
                joined = `${basePath}/${relPath}`
            } catch {
                joined = `${base.replace(/\/+$/, "")}/${cleanUrl.replace(/^\/+/, "")}`
            }
        } else {
            const basePath = base.replace(/\/+$/, "")
            const relPath = cleanUrl.replace(/^\/+/, "")
            joined = `${basePath}/${relPath}`
        }
    }

    if (!joined.startsWith("/")) {
        joined = `/${joined}`
    }

    return joined.replace(/\/+/g, "/")
}

export const isUnsecureUrl = (url?: string, baseUrl: string = ""): boolean => {
    const pathname = getRequestPathname(url, baseUrl)
    if (!pathname) return false

    return UNSECURE_URL_PATTERNS.some((pattern) => pattern.test(pathname))
}
